import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { AppointmentType, InteractionType, KeyValues10, KeyValues10Date, LocalService, Status, TriggeredEvent, WorkingRangeType } from '../../../service/local.service';

@Component({
  selector: 'app-edit-appointment',
  templateUrl: './edit-appointment.component.html',
  styleUrls: ['./edit-appointment.component.scss']
})
export class EditAppointmentComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["appointments"]; string; message: string = ''; isRedAlert: boolean = true;
  workingRangeType: WorkingRangeType = WorkingRangeType.Appoinment; appointmentDate: KeyValues10;
  businessId = ''; content: KeyValues10; id = ''; appointmentType: AppointmentType; relationShipType = InteractionType.None;
  providerId = ''; customerId = ''; notes = ''; appointmentChildId = ''; interactionType = 1; isViewMode = false;
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal, private billingManagementService: BillingManagementService) { }

  ngOnInit(): void {
    if (!this.isViewMode && this.interactionType == 1)
      this.isViewMode = true;
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  onLoad() {
    if (this.id != '') {
      this.billingManagementService.getAppointment(this.id).subscribe(result => {
        this.content = result.content;
        this.appointmentDate = result.date;
        this.appointmentType = parseInt(this.content.v2);
        this.relationShipType = this.appointmentType == AppointmentType.ServiceProvider ? InteractionType.ServiceProvider : InteractionType.Business;
      });
    } else {
      this.relationShipType = this.appointmentType == AppointmentType.ServiceProvider ? InteractionType.ServiceProvider : InteractionType.Business;
      this.content = {
        key: '',
        v1: '',//AppointmentOn
        v2: this.appointmentType.toString(),//AppointmentType
        v3: this.customerId,//CustomerId,
        v4: this.businessId,//ParentId
        v5: this.notes,//Notes
        v6: this.providerId ? this.providerId : this.localService.selected.user,//ProviderId
        v7: '0'
      } as KeyValues10;
      this.appointmentDate = null;
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.content.v10 = this.appointmentChildId;
    this.billingManagementService.saveAppointment({ content: this.content, date: this.appointmentDate } as KeyValues10Date).subscribe(result => {
      if (result.status == Status.Success) {
        this.activeModal.close({ event: TriggeredEvent.Ok, data: result.id });
      }
    });
  }

  onDateUpdate(value) {
    this.appointmentDate = value;
  }

  onUserUpdated(data, index) {
    switch (index) {
      case 1: {
        this.content.v3 = data;
      } break;
      case 2: {
        this.content.v6 = data;
      } break;
    }
  }
}
